<template>
	<div class="index home" >
		<Menu></Menu>
		<div class="swiper mySwiper" @wheel="handleWheel" style="margin-top: 80px;">
			<div class="swiper-wrapper" :style="'height:'+pageHeight+'px'">
				<div class="swiper-slide">
					<img src="../assets/img/yiping.jpg" alt="" />
				</div>
				<div class="swiper-slide">
					<div class="companyProfile">
						<div class="companyProfile-name">
							<div class="companyProfile-eglish">
								Company Profile
							</div>
							<div class="companyProfile-chinese">
								企业简介
							</div>
						</div>
						<el-tabs tab-position="left" :style="'height:'+pageHeightTwo+'px'">
						    <el-tab-pane label="企业简介">
								<div class="companyProfile-flex">
									<div>
										<img src="../assets/img/swiper2bgp.png" alt="" />
									</div>
									<div class="companyProfile-flex-text">
										<div class="companyProfile-flex-main">
											集团是黑龙江省再生资源行业龙头企业，全国再生资源行业骨干企业。
										</div>
										<div class="companyProfile-flex-main">
											集团长期致力于固体废物资源化利用和生态环境资源可持续发展，以“建设资源节约型，环境友好型社会”为指导，以“挖掘城市矿产，建设美好家园”为使命，打造区域循环经济与再生资源回收体系的“全产业链”。
										</div>
										<div class="companyProfile-flex-main">
											为推动黑龙江省循环经济再生资源产业实现工业化进程和高质量发展，推进生态文明建设、助力实现碳达标碳中和目标做出积极贡献。
										</div>
										<div class="readMore companyProfile-flex-main">
											<div class="readMore-left"><div></div></div><div>Read More</div>
										</div>
									</div>
								</div>
							</el-tab-pane>
						    <el-tab-pane label="企业荣誉">
								<div class="companyProfile-flex">
									<div>
										<img src="../assets/img/swiper2bgp.png" alt="" />
									</div>
									<div class="companyProfile-flex-text">
										<div class="companyProfile-flex-tiao">
											中国再生资源回收利用协会副会长单位
										</div>
										<div class="companyProfile-flex-tiao">
											中国循环经济协会常务理事单位
										</div>
										<div class="companyProfile-flex-tiao">
											中国废钢铁应用协会副会长单位
										</div>
										<div class="companyProfile-flex-tiao">
											中国再生资源行业百强企业
										</div>
										<div class="companyProfile-flex-tiao">
											中国再生资源行业“AAA级信用用企业”
										</div>
										<div class="companyProfile-flex-tiao">
											哈尔滨发展经济贡献奖
										</div>
										<div class="companyProfile-flex-tiao">
											哈尔滨市优秀信用中小工业企业
										</div>
										<div class="companyProfile-flex-tiao">
											诚信示范单位(企业)
										</div>
										<div class="companyProfile-flex-tiao">
											中国再生资源骨干企业
										</div>
										<div class="companyProfile-flex-tiao">
											黑龙江省再生资源龙头企业
										</div>
										<div class="companyProfile-flex-tiao">
											哈尔滨市民营企业50强
										</div>
										<div class="companyProfile-flex-tiao">
											哈尔滨民营制造业企业50强
										</div>
									</div>
								</div>
							</el-tab-pane>
						    <el-tab-pane label="发展历程">
								<div class="development-course">
									<div class="development-course-left">
									 	<div class="development-course-one"></div>
										<div class="development-course-two"></div>
										<div class="development-course-three">2014</div>
										<div class="development-course-four">2014</div>
										<div class="development-course-text">
											园区被国家发改委、财政部批复为国家“城市矿产”示范基地，是国家十二五规划期间循环经济重大项目。
										</div>
									</div>
									<div class="development-course-right">
									 	 <div class="development-course-five"></div>
									 	 <div class="development-course-six"></div>
									 	 <div class="development-course-seven">2015</div>
									 	 <div class="development-course-eight">2015</div>
										 <div class="development-course-content">获得哈尔滨市工信委颁发“哈尔滨市优秀信用中小工业企业”称号。</div>
									</div>
									<div class="development-course-left">
									 	<div class="development-course-one"></div>
										<div class="development-course-two"></div>
										<div class="development-course-three">2016</div>
										<div class="development-course-four">2016</div>
										<div class="development-course-text">
											获得市文明办、诚信办等颁发的“诚信示范单位(企业)”称号；
											
											连续3年被哈尔滨市委市政府授予“哈尔滨发展经济贡献奖”；
											
											被纳入黑龙江省及哈尔滨市国民经济和社会发展第十三个五年规划，列入哈尔滨市十三五规划循环型产业体系重大工程项目。

										</div>
									</div>
									<div class="development-course-right">
									 	 <div class="development-course-five"></div>
									 	 <div class="development-course-six"></div>
									 	 <div class="development-course-seven">2018</div>
									 	 <div class="development-course-eight">2018</div>
										 <div class="development-course-content">连续6年被评为“中国再生资源行业百强企业”、中国再生资源行业“AAA级信用企业”</div>
									</div> 
									<div class="development-course-left">
									 	<div class="development-course-one"></div>
										<div class="development-course-two"></div>
										<div class="development-course-three">2020</div>
										<div class="development-course-four">2020</div>
										<div class="development-course-text">
											被纳入黑龙江省及哈尔滨市国民经济和社会发展第十四个五年规划和二〇三五年远景目标纲要。
										</div>
									</div>
									<div class="development-course-right">
									 	 <div class="development-course-five"></div>
									 	 <div class="development-course-six"></div>
									 	 <div class="development-course-seven">2023</div>
									 	 <div class="development-course-eight">2023</div>
										 <div class="development-course-content">入选哈尔滨市民营企业50强、民营制造业企业50强。</div>
									</div>
								</div>
							</el-tab-pane>
						    <el-tab-pane label="领导关怀">
								 <div class="swiper mySwiperGuanhuai">
								    <div class="swiper-wrapper">
								      <div class="swiper-slide">
										  <img src="../assets/img/pic1.png" alt="" />
										  <div class="guanhuai-text">
											 <div>
											 	黑龙江省委书记、省长王文涛	  
											 </div>
											  <div>
											  		到社区参加生活垃圾分类志愿者服务活动									  
											  </div>
										  </div>
									  </div>
								      <div class="swiper-slide">
										   <img src="../assets/img/pic2.png" alt="" />
										    <div class="guanhuai-text">
												<div>
													黑龙江省委书记、省人大常委会主任张庆伟
												</div>
												<div>
													参加节能宣传周生活垃圾分类活动 									  
												</div>
										    </div>
									  </div>
								      <div class="swiper-slide">
										   <img src="../assets/img/pic3.png" alt="" />
										   <div class="guanhuai-text">
										   	<div>
										   		黑龙江省委常委、副省长王永康
										   	</div>
										   	<div>
										   		到社区参加生活垃圾分类志愿者服务活动 									  
										   	</div>
										   </div>
									  </div>
								      <div class="swiper-slide">
										   <img src="../assets/img/pic4.png" alt="" />
										   <div class="guanhuai-text">
										   	<div>
										   		黑龙江省政府副省长聂云凌
										   	</div>
										   	<div>
										   		调研松北区生活垃圾分类示范社区 									  
										   	</div>
										   </div>
									  </div>
								    </div>
								    <div class="swiper-pagination"></div>
								  </div>
							</el-tab-pane>
							<el-tab-pane label="中亚印象">
								<div class="yinxiang" :style="'height:'+pageHeightTwo+'px'">
									<div class="yinxiang-box" :style="'height:'+pageHeightThree+'px'">
										<div class="yinxiang-box-left">
											<div>
												<img src="../assets/img/img1.jpg" alt="" />
											</div>
											<div class="yinxiang-box-left-box">
												<div>
													<img src="../assets/img/img2.jpg" alt="" />
												</div>
												<div>
													<img src="../assets/img/img3.jpg" alt="" />
												</div>
											</div>
										</div>
										<div class="yinxiang-box-right">
											<img src="../assets/img/img4.jpg" alt="" />
										</div>
									</div>
								</div>
							</el-tab-pane>
						  </el-tabs>
					</div>
					<div class="companyProfile-box">
						<div class="companyProfile-content">
							<div>
								<div class="companyProfile-name-child">31</div>
								<div class="companyProfile-product">集团下属31家子公司</div>
							</div>
							<div>
								<div class="companyProfile-name-child">100<span id="">强</span></div>
								<div class="companyProfile-product">中国再生资源行业百强企业</div>
							</div>
							<div>
								<div class="companyProfile-name-child">50<span id="">强</span></div>
								<div class="companyProfile-product">哈尔滨市民营企业50强</div>
							</div>
							<div>
								<div class="companyProfile-name-child">AAA<span id="">强</span></div>
								<div class="companyProfile-product">中国再生资源行业“AAA级信用企业”</div>
							</div>
						</div>
					</div>
				</div>
				<div class="swiper-slide third-screen">
					<div class="third-screen-box">
						<div class="third-screen-little-title">Recycling System of waste materials</div>
						<div class="third-screen-title">废旧物资循环利用体系</div>
						<div class="third-screen-content">
							<div class="third-screen-bgp1" :style="imageStyles"></div>
							<div class="third-screen-bgp2" :style="imageStyle"></div>
							<div class="third-screen-bgp3" :style="imageStyles"></div>
							<div class="third-screen-center">
								<div class="third-screen-center1">
									<div class="third-screen-text1"></div>
								</div>
								<div class="third-screen-center2">
									<div class="third-screen-text2"></div>
								</div>
								<div class="third-screen-center3">
									<div class="third-screen-text3"></div>
								</div>
								<div class="third-screen-center4">
									<div class="third-screen-text4"></div>
								</div>
							</div>
							<div class="third-screen-center-text">
								<div>
									城市矿产
								</div>
								<div>
									示范基地
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="swiper-slide" style="display: none;">
					<div class="third-screen-little-title" style="margin-top: 80px;">Four functional areas</div>
					<div class="third-screen-title">四大功能区</div>
					<div class="four-big-box">
						 
					</div>
				</div>
				<div class="swiper-slide" id="eight-big">
					<div class="third-screen-little-title" style="width:80%;margin: 80px auto 0 auto;text-align: left;">Business segment</div>
					<div class="third-screen-title" style="text-align: left;width:80%;margin:0 auto;">八大业务板块</div>
					<div class="banluai">
						 <div class="swiper-container swiper-container-eight" >
						     <div class="swiper-wrapper"  :style="'height:'+pageHeightTwo+'px'">
						       <div class="swiper-slide">
								   <img src="../assets/img/eight1.jpg" alt="" />
								   <div class="eight-center-text">废家电绿色拆解中心</div>
							   </div>
						       <div class="swiper-slide">
								   <img src="../assets/img/eight2.jpg" alt="" />
								   <div class="eight-center-text">锂电池回收处理中心</div>
							   </div>
						       <div class="swiper-slide">
								   <img src="../assets/img/eight3.jpg" alt="" />
								    <div class="eight-center-text">报废汽车绿色拆解中心</div>
							   </div>
						       <div class="swiper-slide">
								   <img src="../assets/img/eight4.jpg" alt="" />
								    <div class="eight-center-text">废塑料绿色分拣加工中心 </div>
								</div>
						       <div class="swiper-slide">
								   <img src="../assets/img/eight5.jpg" alt="" />
								    <div class="eight-center-text">塑料高分子新材料制造中心</div>
							   </div>
						       <div class="swiper-slide">
								   <img src="../assets/img/eight6.jpg" alt="" />
								    <div class="eight-center-text">废钢铁绿色分拣加工中心</div>
							   </div>
						       <div class="swiper-slide">
								   <img src="../assets/img/eight7.jpg" alt="" />
								    <div class="eight-center-text">废轮胎回收处理中心</div>
							   </div>
						       <div class="swiper-slide">
								   <img src="../assets/img/eight8.jpg" alt="" />
								    <div class="eight-center-text">废纸绿色分拣加工中心</div>
							   </div>
						     </div>
							  <div class="swiper-button-next"></div>
							     <div class="swiper-button-prev"></div>
						     <!-- Add Pagination -->
						     <div class="swiper-pagination"></div>
						   </div>
					</div>
				</div>
				<div class="swiper-slide">
					<div class="last-screen">
						<div class="last-screen-right">
							<div class="last-screen-xie"></div>
							<div class="last-screen-box">
								<div class="last-screen-img">
									<img src="../assets/img/logoBox.png" alt="" style="margin-top: 12px;" />
								</div>
								<div class="last-screen-tel">联系电话</div>
								<div class="last-screen-phone">400-0451-000</div>
								<div class="last-screen-addressName">地址</div>
								<div class="last-screen-address">哈尔滨市松北区智谷二街3043号8号楼8层</div>
								<div class="line"></div>
								<div class="last-screen-qicode">
									<div class="last-screen-qicode1">
										<img src="../assets/img/qrCode1.jpg" alt="" />
										<div class="zhongyaqr">中亚环保小程序</div>
									</div>
									<div class="last-screen-qicode2">
										<img src="../assets/img/qrCode2.jpg" alt="" />
										<div class="zhongyaqr">中亚回收小程序</div>
									</div>
								</div>
							</div>
						</div>
						<div class="last-screen-bottom">黑ICP备2023004882号</div>
					</div>
				</div>
			</div>
			<div class="swiper-pagination"></div>
			 <div class="swiper-scrollbar"></div>
		</div>
		<div class="mobile-home">
			<div>
				<img src="../assets/img/mbHome.jpg" alt="" />
			</div>
			<div class="home-mb-second-screen">
				<div class="home-mb-second-screen-href">
					<div>Company Profile</div>
					<div>Read More</div>
				</div>
				<div class="home-mb-second-screen-title">企业简介</div>
				<div class="home-mb-second-screen-tab">
					<el-tabs v-model="activeName" >
					    <el-tab-pane label="企业简介" name="first">
							<div class="tab-mb-text">
								集团是黑龙江省再生资源行业龙头企业，全国再生资源行业骨干企业。
							</div>
							<div class="tab-mb-text">
								集团长期致力于固体废物资源化利用和生态环境资源可持续发展，以“建设资源节约型，环境友好型社会”为指导，以“挖掘城市矿产，建设美好家园”为使命，打造区域循环经济与再生资源回收体系的“全产业链”。
							</div>
							<div class="tab-mb-text">
								为推动黑龙江省循环经济再生资源产业实现工业化进程和高质量发展，推进生态文明建设、助力实现碳达标碳中和目标做出积极贡献。
							</div>
							</el-tab-pane>
					    <el-tab-pane label="企业荣誉" name="second">
							<div class="companyProfile-flex-tiao">
								中国再生资源回收利用协会副会长单位
							</div>
							<div class="companyProfile-flex-tiao">
								中国循环经济协会常务理事单位
							</div>
							<div class="companyProfile-flex-tiao">
								中国废钢铁应用协会副会长单位
							</div>
							<div class="companyProfile-flex-tiao">
								中国再生资源行业百强企业
							</div>
							<div class="companyProfile-flex-tiao">
								中国再生资源行业“AAA级信用用企业”
							</div>
							<div class="companyProfile-flex-tiao">
								哈尔滨发展经济贡献奖
							</div>
							<div class="companyProfile-flex-tiao">
								哈尔滨市优秀信用中小工业企业
							</div>
							<div class="companyProfile-flex-tiao">
								诚信示范单位(企业)
							</div>
							<div class="companyProfile-flex-tiao">
								中国再生资源骨干企业
							</div>
							<div class="companyProfile-flex-tiao">
								黑龙江省再生资源龙头企业
							</div>
							<div class="companyProfile-flex-tiao">
								哈尔滨市民营企业50强
							</div>
							<div class="companyProfile-flex-tiao">
								哈尔滨民营制造业企业50强
							</div>
						</el-tab-pane>
					    <el-tab-pane label="发展历程" name="third">
							<div class="swiper-container-mb">
							        <div class="swiper-wrapper">
							            <div class="swiper-slide" data-hash="slide1">
											<div class="development-course-left">
											 	<div class="development-course-one"></div>
												<div class="development-course-two"></div>
												<div class="development-course-three">2014</div>
												<div class="development-course-four">2014</div>
												<div class="development-course-text">
													园区被国家发改委、财政部批复为国家“城市矿产”示范基地，是国家十二五规划期间循环经济重大项目。
												</div>
											</div>
										</div>
										<div class="swiper-slide" data-hash="slide2">
											<div class="development-course-right">
											 	 <div class="development-course-five"></div>
											 	 <div class="development-course-six"></div>
											 	 <div class="development-course-seven">2015</div>
											 	 <div class="development-course-eight">2015</div>
												 <div class="development-course-content">获得哈尔滨市工信委颁发“哈尔滨市优秀信用中小工业企业”称号。</div>
											</div>
										</div>
										<div class="swiper-slide" data-hash="slide3">
											<div class="development-course-left">
											 	<div class="development-course-one"></div>
												<div class="development-course-two"></div>
												<div class="development-course-three">2016</div>
												<div class="development-course-four">2016</div>
												<div class="development-course-text">
													获得市文明办、诚信办等颁发的“诚信示范单位(企业)”称号；
													
													连续3年被哈尔滨市委市政府授予“哈尔滨发展经济贡献奖”；
													
													被纳入黑龙江省及哈尔滨市国民经济和社会发展第十三个五年规划，列入哈尔滨市十三五规划循环型产业体系重大工程项目。
											
												</div>
											</div>
										</div>
										<div class="swiper-slide" data-hash="slide4">
											<div class="development-course-right">
											 	 <div class="development-course-five"></div>
											 	 <div class="development-course-six"></div>
											 	 <div class="development-course-seven">2018</div>
											 	 <div class="development-course-eight">2018</div>
												 <div class="development-course-content">连续6年被评为“中国再生资源行业百强企业”、中国再生资源行业“AAA级信用企业”</div>
											</div> 
										</div>
										<div class="swiper-slide" data-hash="slide5">
											<div class="development-course-left">
											 	<div class="development-course-one"></div>
												<div class="development-course-two"></div>
												<div class="development-course-three">2020</div>
												<div class="development-course-four">2020</div>
												<div class="development-course-text">
													被纳入黑龙江省及哈尔滨市国民经济和社会发展第十四个五年规划和二〇三五年远景目标纲要。
												</div>
											</div>
										</div>
										<div class="swiper-slide" data-hash="slide6">
											<div class="development-course-right">
											 	 <div class="development-course-five"></div>
											 	 <div class="development-course-six"></div>
											 	 <div class="development-course-seven">2023</div>
											 	 <div class="development-course-eight">2023</div>
												 <div class="development-course-content">入选哈尔滨市民营企业50强、民营制造业企业50强。</div>
											</div>
										</div>
							        </div>
							        <!-- Add Pagination -->
							        <div class="swiper-pagination"></div>
							        <!-- Add Arrows -->
							        <div class="swiper-button-next"></div>
								<div class="swiper-button-prev"></div>
							</div>
						</el-tab-pane>
					    <el-tab-pane label="领导关怀" name="fourth">
							<div class="swiper-container-mb-guan">
							        <div class="swiper-wrapper">
							            <div class="swiper-slide">
										  <img src="../assets/img/pic1.png" alt="" />
										  <div class="guanhuai-text">
											 <div>
												黑龙江省委书记、省长王文涛	  
											 </div>
											  <div>
													到社区参加生活垃圾分类志愿者服务活动									  
											  </div>
										  </div>
							            </div>
							            <div class="swiper-slide">
										   <img src="../assets/img/pic2.png" alt="" />
											<div class="guanhuai-text">
												<div>
													黑龙江省委书记、省人大常委会主任张庆伟
												</div>
												<div>
													参加节能宣传周生活垃圾分类活动 									  
												</div>
											</div>
							            </div>
							            <div class="swiper-slide">
										   <img src="../assets/img/pic3.png" alt="" />
										   <div class="guanhuai-text">
											<div>
												黑龙江省委常委、副省长王永康
											</div>
											<div>
												到社区参加生活垃圾分类志愿者服务活动 									  
											</div>
										   </div>
							            </div>
							            <div class="swiper-slide">
										   <img src="../assets/img/pic4.png" alt="" />
										   <div class="guanhuai-text">
											<div>
												黑龙江省政府副省长聂云凌
											</div>
											<div>
												调研松北区生活垃圾分类示范社区 									  
											</div>
										   </div>
							            </div>
							        </div>
							        <!-- Add Pagination -->
							        <div class="swiper-pagination"></div>
							        <!-- Add Arrows -->
							        <div class="swiper-button-next"></div>
							        <div class="swiper-button-prev"></div>
							    </div>
						</el-tab-pane>
						<el-tab-pane label="中亚印象" name="fifth">
							<div>
								<img src="../assets/img/mbyingxiang.jpg" alt="" />
							</div>
						</el-tab-pane>
					  </el-tabs>
				</div>
			</div>
			<div class="companyProfile-box">
				<div class="companyProfile-content">
					<div>
						<div class="companyProfile-name-child">31</div>
						<div class="companyProfile-product">集团下属31家子公司</div>
					</div>
					<div>
						<div class="companyProfile-name-child">100<span id="">强</span></div>
						<div class="companyProfile-product">中国再生资源行业百强企业</div>
					</div>
					<div>
						<div class="companyProfile-name-child">50<span id="">强</span></div>
						<div class="companyProfile-product">哈尔滨市民营企业50强</div>
					</div>
					<div>
						<div class="companyProfile-name-child">AAA<span id="">强</span></div>
						<div class="companyProfile-product">中国再生资源行业“AAA级信用企业”</div>
					</div>
				</div>
			</div>
			<div class="third-screen-box-mb">
				<div class="third-screen-box">
					<div class="third-screen-little-title">Recycling System of waste materials</div>
					<div class="third-screen-title">废旧物资循环利用体系</div>
					<div class="third-screen-content">
						<div class="third-screen-bgp1" :style="imageStyles"></div>
						<div class="third-screen-bgp2" :style="imageStyle"></div>
						<div class="third-screen-bgp3" :style="imageStyles"></div>
						<div class="third-screen-center">
							<div class="third-screen-center1">
								<div class="third-screen-text1"></div>
							</div>
							<div class="third-screen-center2">
								<div class="third-screen-text2"></div>
							</div>
							<div class="third-screen-center3">
								<div class="third-screen-text3"></div>
							</div>
							<div class="third-screen-center4">
								<div class="third-screen-text4"></div>
							</div>
						</div>
						<div class="third-screen-center-text">
							<div>
								城市矿产
							</div>
							<div>
								示范基地
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="eight-big">
				<div class="third-screen-little-title" style="width:80%;margin:30px auto 0 auto;text-align: left;">Business segment</div>
				<div class="third-screen-title" style="text-align: left;width:80%;margin:0 auto;">八大业务板块</div>
				<div class="banluai-mb">
					 <div class="swiper-container swiper-container-mb-ba" >
						 <div class="swiper-wrapper">
							 <div class="swiper-slide">
								   <img src="../assets/img/eight1.jpg" alt="" />
								   <div class="eight-center-text">废家电绿色拆解中心</div>
							 </div>
							 <div class="swiper-slide">
								   <img src="../assets/img/eight2.jpg" alt="" />
								   <div class="eight-center-text">锂电池回收处理中心</div>
							 </div>
							 <div class="swiper-slide">
								   <img src="../assets/img/eight3.jpg" alt="" />
									<div class="eight-center-text">报废汽车绿色拆解中心</div>
							 </div>
							 <div class="swiper-slide">
							   <img src="../assets/img/eight4.jpg" alt="" />
								<div class="eight-center-text">废塑料绿色分拣加工中心 </div>
							</div>
							 <div class="swiper-slide">
								   <img src="../assets/img/eight5.jpg" alt="" />
									<div class="eight-center-text">塑料高分子新材料制造中心</div>
							 </div>
							 <div class="swiper-slide">
								   <img src="../assets/img/eight6.jpg" alt="" />
									<div class="eight-center-text">废钢铁绿色分拣加工中心</div>
							 </div>
							 <div class="swiper-slide">
								   <img src="../assets/img/eight7.jpg" alt="" />
									<div class="eight-center-text">废轮胎回收处理中心</div>
							 </div>
							 <div class="swiper-slide">
								   <img src="../assets/img/eight8.jpg" alt="" />
									<div class="eight-center-text">废纸绿色分拣加工中心</div>
							 </div>
						 </div>
						 <div class="swiper-pagination"></div>
						 <div class="swiper-button-next"></div>
						 <div class="swiper-button-prev"></div>
					   </div> 
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'index',
    components:{
      Menu,
	  Footer
    },
     data () {
      return {
		pageHeight:0,
		pageHeightTwo:0,
		pageHeightThree:0,
		rotationDegrees:0,
		 activeName: 'first'
      };
    },
	computed: {
	    imageStyle() {
	      return {
	        transform: `rotate(${this.rotationDegrees}deg)`
	      };
	    },
		imageStyles() {
		  return {
		    transform: `rotate(-${this.rotationDegrees}deg)`
		  };
		}
	},
	mounted(){
		this.pageHeight = window.innerHeight - 80;
		this.pageHeightTwo = window.innerHeight - 392;
		this.pageHeightThree= window.innerHeight - 460;
		this.startRotation()
		new Swiper(".mySwiper", {
		  direction: "vertical",
		  slidesPerView: 1,
		  spaceBetween: 30,
		  mousewheel: true,
		 
		});
		new Swiper(".mySwiperGuanhuai", {
		      slidesPerView: 3,
		      spaceBetween: 30,
		      pagination: {
		        el: ".swiper-pagination",
		        clickable: true,
		      },
		});
		new Swiper('.swiper-container-eight', {
			slidesPerView: 3,
			spaceBetween: 30,
			centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			  },
		});
		new Swiper('.swiper-container-mb', {
			pagination: '.swiper-pagination',
			paginationClickable: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			  },
			spaceBetween: 30,
			hashnav: true,
			hashnavWatchState: true,
			slidesPerView:1.5,
		});
		new Swiper('.swiper-container-mb-guan', {
			pagination: '.swiper-pagination',
			paginationClickable: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			spaceBetween: 30,
			hashnav: true,
			hashnavWatchState: true,
			slidesPerView:1.5,
		});
		new Swiper('.swiper-container-mb-ba', {
			pagination: '.swiper-pagination',
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			paginationClickable: true,
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			autoplayDisableOnInteraction: false
		});
	},
	methods: {
		startRotation() {
		    this.rotationInterval = setInterval(() => {
				this.rotationDegrees += 10; // 每秒旋转10度
		    }, 100);
		},
		aboutUs(){
			this.$router.push({
				path:'/AboutUs',
				query:{
					id:"AboutUs"
				}
			})	
		},
		handleWheel(){
			console.log(1111);
		}
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/login.scss';
@import '../assets/scss/swiper.css';
html,body {
	position: relative;
	height: 100%;
}
body {
	margin: 0;
	padding: 0;
}
.swiper {
	width: 100%;
	height: 100%;
}
.swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #fff;
}
.swiper-slide img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.banluai .swiper-container {
      width: 100%;
      height: 100%;
    }
.banluai .swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #000;
	position: relative;
	/* Center slide text vertically */
	display: -webkit-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	-webkit-justify-content: center;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;
	transition: 300ms;
	transform: scale(0.8);
}
.banluai .swiper-slide-active,.swiper-slide-duplicate-active{
	transform: scale(1);
}	
</style>


// WEBPACK FOOTER //
// src/components/home.vue